module.exports = __webpack_public_path__ + "static/kz-1d865ecd6e6a9761e6550eb6eb85b357.svg";